import * as React from 'react';

export const RenderHtml = (props: {html: string}) => {
	const obj = {__html: props.html};
	return <span dangerouslySetInnerHTML={obj}/>;
};
